export default "__VITE_ASSET__b4af1bac__"